import * as Styled from './StyleButtonBadge';

const CompleteBadge = () => {
  return <Styled.Button color="brown">답변 완료</Styled.Button>;
};

export default CompleteBadge;
